export * from './TimePipe';



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/pipes/pipes.ts